import { MINDMAP_ROOT_NODE_ID } from './MindmapConstants';
import type { Mindmap } from './MindmapTypes';

export function getRootNodeId() {
  return MINDMAP_ROOT_NODE_ID;
}

const PREFIX = 'mm_';

export function getNextNodeId(mindmap: Mindmap): string {
  let max = 0;
  for (const n of mindmap.nodes) {
    if (n.id.startsWith(PREFIX)) {
      const num = Number(n.id.slice(PREFIX.length));
      if (!Number.isNaN(num)) max = Math.max(max, num);
    }
  }
  return `${PREFIX}${max + 1}`;
}
